<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'GOP',

    metaInfo: { title: 'GOP Dashboard' },

    extends: View,

    mixins: [
      LoadSections([
        'gop',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'GOP',
      },
    },
  }
</script>
